import React from "react";
import { Link } from "react-router-dom";
import ChevronRight from "@material-ui/icons/ChevronRight";
import Payment from "@material-ui/icons/Payment";
import Payments from "@material-ui/icons/LocalAtm";
import Accessible from "@material-ui/icons/Accessible";
import "./StoreIdentity.css";

export default function StoreIdentity({ store, language, details = false, online, cash, minimum }) {
  const settings = store.settings || {};
  const arabic = language === "arabic";
  const name = arabic ? store.ar_name || store.name : store.name;
  const slogan = arabic ? store.ar_slogan || store.slogan : store.slogan;
  const showLogo = arabic && settings.show_logo_ar ? settings.show_logo_ar : settings.show_logo;
  const logo = arabic && settings.show_logo_ar ? store.logo_ar || store.logo : store.logo;
  const Body = details ? "div" : Link;
  return (
    <Body {...(!details ? { to: "/contact" } : {})} className={`sf-store-identity${details ? " sf-store-identity--details" : ""}`} dir={arabic ? "rtl" : "ltr"}>
      {showLogo && logo && <img className="sf-store-identity__logo" src={logo} alt="" />}
      <div className="sf-store-identity__copy">
        {details && <p className="sf-store-identity__eyebrow">{arabic ? "معلومات المتجر" : "Store information"}</p>}
        {details ? <h1>{name}</h1> : <h2>{name}</h2>}
        {slogan && <p className="sf-store-identity__slogan">{slogan}</p>}
        {!settings.is_menu && (online || cash || minimum || settings.wheelchair_accessible) && <div className="sf-store-identity__facts">
          {online && <span><Payment aria-hidden="true" />{arabic ? "بطاقات" : "Cards"}</span>}
          {cash && <span><Payments aria-hidden="true" />{arabic ? "نقداً" : "Cash"}</span>}
          {minimum && <span>{minimum}</span>}
          {settings.wheelchair_accessible && <span title={arabic ? "مناسب للكراسي المتحركة" : "Wheelchair accessible"}><Accessible /><span className="sr-only">{arabic ? "مناسب للكراسي المتحركة" : "Wheelchair accessible"}</span></span>}
        </div>}
      </div>
      {!details && <span className="sf-store-identity__arrow"><ChevronRight /></span>}
    </Body>
  );
}
